import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@wfp-root-app/store/store';
import State from '@wfp-root-app/store/state';
import { BeneficiaryPrimaryIdentifierToShow } from '@wfp-root-app/appConfig';

import { RowMenu } from '../../utils/RowMenu';
import BeneficiaryImportPage from './BeneficiaryMassImport';
import TaxIdFamilyTaxIdMapping from './TaxIdFamilyTaxIdMapping';
import RemoveEntitlements from './RemoveEntitlements';
import { ActionCreators, FileUploadListType } from './fileUpload';
import RemoveDeduplications from './RemoveDeduplications';

const FileUploadContainer: React.FC = () => {
    const activeTab = useSelector((state: State) => state.fileUpload.activeTab);
    const beneficiaryPrimaryIdentifierType = useSelector(
        (state: State) => state.appConfig.beneficiaryPrimaryIdentifierType
    );
    const dispatch = useAppDispatch();

    const tabs = [
        FileUploadListType.FileUpload,
        FileUploadListType.FamilyMapping,
        FileUploadListType.RemoveEntitlements,
        // FileUploadListType.RemoveDeduplications, TODO - first discuss logic of removal only deduplications with Houman
    ];

    const tabDisplayNames = {
        [FileUploadListType.FamilyMapping]: `HoH to HM ${BeneficiaryPrimaryIdentifierToShow[beneficiaryPrimaryIdentifierType]} Mapping`,
    };

    const onSelectTab = (tab: FileUploadListType) => {
        dispatch(ActionCreators.changeTab(tab));
    };

    const renderFileUploadList = () => {
        switch (activeTab) {
            case FileUploadListType.FileUpload:
                return <BeneficiaryImportPage />;
            case FileUploadListType.FamilyMapping:
                return <TaxIdFamilyTaxIdMapping />;
            case FileUploadListType.RemoveEntitlements:
                return <RemoveEntitlements />;
            case FileUploadListType.RemoveDeduplications:
                return <RemoveDeduplications />;
        }
    };

    return (
        <>
            <RowMenu activeTab={activeTab} onSelectTab={onSelectTab} tabDisplayNames={tabDisplayNames} tabs={tabs} />
            {renderFileUploadList()}
        </>
    );
};

FileUploadContainer.displayName = 'FileUploadContainer';

export { FileUploadContainer };
